import React from 'react';
import './Skills.css'

const Skills = () => {
    return (
        <div data-aos="flip-left" data-aos-duration="1000">
            <ul>
                <li><span>UI/UX</span><br />Designing Web/App interfaces</li>
                <li><span>UI/UX</span><br />Designing Web/App interfaces</li>
                <li><span>UI/UX</span><br />Designing Web/App interfaces</li>
            </ul>
        </div>
    );
};

export default Skills;